import { render, staticRenderFns } from "./Speisekartenew.vue?vue&type=template&id=37ba4407&scoped=true"
import script from "./Speisekartenew.vue?vue&type=script&lang=js"
export * from "./Speisekartenew.vue?vue&type=script&lang=js"
import style0 from "./Speisekartenew.vue?vue&type=style&index=0&id=37ba4407&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ba4407",
  null
  
)

export default component.exports